import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../types/Product';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { QuoteService } from '../../services/quotes.service';
import { FeedbackService } from '../feedback/feedback.service';
import { firstValueFrom } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { Router, RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, RouterLink, CurrencyPipe, FaIconComponent],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  @Input() product!: Product;
  @Input("categoryName") productName!: string;
  @Input() quoteId: string | undefined = undefined;

  public feedbackIcon = faComments;

  constructor(private sessionService: SessionService,
    private quoteService: QuoteService,
    private router: Router,
    private feedbackService: FeedbackService) { }


  async addProductToQuote(quoteId: string, product: Product) {
    // Start at the product minimum, the server rejects any lower quantity
    await firstValueFrom(this.quoteService.updateQuoteItem(quoteId, product.id, { quantity: product.minimumOrderQuantity ?? 1 }));
    // Forward to quote
    this.router.navigate(["/", "quote-view", quoteId]);
  }

  launchFeedback(product: Product) {
    this.feedbackService.open(
      "websupport@us.digi-group.com",
      `Product Listing Issue for PricePoint`,
      `Hello DIGI America Web Support,
  
  I’m reaching out because I’m experiencing an issue with a product listing. Here are the product details:
  
  Item Category: ${this.productName}
  Item Name: ${product.name}
  SKU: ${product.sku}
  
  Issue Description:
  [Please describe the problem issue experiencing here, including any error messages, unexpected behavior, or circumstances when the issue occurs.]
  
  Best regards,
  [Your Name]`);
  }

  hasUpdatePermissions(): boolean {
    return this.sessionService.hasPermission("product:update");
  }

  hasPricePermissions() {
    return this.sessionService.hasPermission("product:update_price");
  }

  objectKeys(anyObject: object) {
    return Object.keys(anyObject);
  }
}
